import Routes, { ROUTE_TYPE } from 'rde-view-common/constants/Routes';
import { copy, isEmpty, isNotEmpty } from 'rde-view-common/scripts/functions';
import Vue from 'vue';
import routeConfig from '~/config/routeConfig';

const qs = require('qs');

/**
 * RDE画面用ルーター
 */
export default ({ app, $config }) => {
  Vue.prototype.$routes = Routes;
  app.$routes = Routes;
  Vue.prototype.$rdeRouter = {
    ...app.router,
    push: async (route, params) => {
      const path = createPath(route.path, params);

      if (isNotEmpty(route.type) && route.type !== routeConfig.ME) {
        let baseUrl;
        if (route.type === ROUTE_TYPE.ENTRIES) {
          baseUrl = $config.viewBaseUrl[`${route.type}_nims`].replace(/\/$/, '');
        } else {
          baseUrl = $config.viewBaseUrl[route.type].replace(/\/$/, '');
        }
        console.log('nextUrl:', baseUrl + path);
        if (isNotEmpty(baseUrl)) {
          window.location.href = baseUrl + path;
        } else {
          await app.router.push(path);
        }
      } else if (app.router.currentRoute.path === path) {
        console.log('nextPath:', path);
        await app.router.go({ path, force: true });
      } else {
        console.log('nextPath:', path);
        await app.router.push(path);
      }
    },
    resolve: (route, params) => {
      const path = createPath(route.path, params);
      const baseUrl = $config.viewBaseUrl[route.type];
      return baseUrl + path;
    }
  };
  app.$rdeRouter = Vue.prototype.$rdeRouter;
};

function createPath(path, params) {
  if (isEmpty(params)) return copy(path);

  let created;
  Object.keys(params)
    .filter(key => path.includes(`:${key}`))
    .forEach(key => {
      created = path.replace(`:${key}`, params[key]);
      delete params[key];
    });

  return created + (isEmpty(params) ? '' : '?' + qs.stringify(params));
}
